import { configureStore } from '@reduxjs/toolkit';

import rootReducer from './reducers';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Lo store contiene funzioni `unsubscribe` (listener Firestore) e
      // oggetti `Date` nei date slice del calendar — disabilito i check per
      // evitare warning rumorosi a ogni dispatch.
      serializableCheck: false,
      immutableCheck: false,
    }),
  devTools: import.meta.env.MODE !== 'production',
});

// Accesso globale allo stato (helper per moduli fuori da React).
export const getGlobalState = () => store.getState();

export default store;
